<div class="position-relative sys-layout" [dir]="languageService.direction()">
    <div class="position-relative row d-flex justify-content-between align-items-center bg-card sys-layout--topbar" dir="ltr">
        <div class="col-6 d-flex justify-content-start">
            @if (systemLayoutService.activeEntityLogo()) {
                <img
                    alt="Entity logo"
                    loading="lazy"
                    class="d-block my-0 entity-logo"
                    [dir]="languageService.direction()"
                    [attr.data-img-type]="systemLayoutService.activeEntity()?.logoHorizontalAttach ? 'horizontal' : 'vertical'"
                    [src]="systemLayoutService.activeEntityLogo()"
                />
            }
        </div>

        <div class="col-6 d-flex justify-content-end">
            @for (theme of ["light", "dark"]; track theme) {
                <img
                    class="d-block my-0 adaa-logo"
                    alt="logo"
                    [class]="'theme-' + theme + '-only'"
                    [src]="'assets/images/adaa_logo_' + (languageService.direction() === 'ltr' ? 'en' : 'ae') + '_' + theme + '.png'"
                    [dir]="languageService.direction()"
                />
            }
        </div>
    </div>

    <adaa-topbar [direction]="languageService.direction()" (toggleSidebar)="toggleSidebar()" />

    <div class="sys-layout--content" [dir]="languageService.direction()">
        <div
            class="sidebar console-heartbeat-slide-right console-heartbeat-slide-right-out"
            [class.full]="sidebarType() === 'full'"
            [class.mini]="sidebarType() === 'mini'"
            [dir]="languageService.direction()"
        >
            <div class="sidebar-header" [dir]="languageService.direction()">
                <button type="button" class="sidebar-toggle" [dir]="languageService.direction()" (click)="toggleSidebar()">
                    <fa-icon [icon]="icon.menu" />
                </button>
            </div>

            <div class="sidebar-navitems">
                @for (item of consoleService.navConsoleItems(); track item) {
                    @if (
                        item.fieldName === "strategyDashboard" ||
                        item.fieldName === "governmentPerformanceDashboard" ||
                        item.fieldName === "internationalProjectsDashboard" ||
                        item.fieldName === "agenticAiDashboard"
                    ) {
                        <a
                            class="sidebar-item d-flex align-items-center pointer"
                            [class]="item.fieldName + '-menu'"
                            role="menuitem"
                            [dir]="languageService.direction()"
                            [attr.title]="item | translateToken: 'name'"
                            *adaaHasPermission="getPermission(item.permissions)"
                            (click)="openAdaaDashboard(item)"
                        >
                            <div class="sidebar-item-icon" [dir]="languageService.direction()">
                                <i [class]="'adaa-icon-' + item.iconKey"></i>
                            </div>

                            @if (sidebarType() === "full") {
                                <div class="sidebar-item-text" [dir]="languageService.direction()">{{ item | translateToken: "name" }}</div>
                            }
                        </a>
                    } @else {
                        <a
                            class="sidebar-item d-flex align-items-center"
                            [class]="item.fieldName + '-menu'"
                            role="menuitem"
                            [dir]="languageService.direction()"
                            [attr.title]="item | translateToken: 'name'"
                            [routerLink]="'/' + item.urlRoute"
                            [routerLinkActive]="'active'"
                            [routerLinkActiveOptions]="{ exact: true }"
                            *adaaHasPermission="getPermission(item.permissions)"
                            (click)="sideNavClick($event)"
                        >
                            <div class="sidebar-item-icon" [dir]="languageService.direction()">
                                @if (
                                    item.fieldName === "nationalStrategiesDashboard" ||
                                    item.fieldName === "employeesPulse" ||
                                    item.fieldName === "employee_pulse_dashboard" ||
                                    item.fieldName === "executiveDashboard"
                                ) {
                                    <i style="font-size: 1.25rem" [class]="'adaa-icon-' + item.iconKey"></i>
                                } @else {
                                    <i [class]="'adaa-icon-' + item.iconKey"></i>
                                }
                            </div>

                            @if (sidebarType() === "full") {
                                <div class="sidebar-item-text" [dir]="languageService.direction()">{{ item | translateToken: "name" }}</div>
                            }
                        </a>
                    }
                }
            </div>

            <div class="sidebar-footer">
                <adaa-color-legend />
                <p class="sidebar-footer-copyright text-center">
                    {{ "leftbar.copy_right" | translate }} <br />
                    ADAA © {{ currentYear() }}
                </p>
            </div>
        </div>

        <div class="page" [class.full]="sidebarType() === 'full'" [class.mini]="sidebarType() === 'mini'" [dir]="languageService.direction()">
            <adaa-breadcrumb></adaa-breadcrumb>
            <div class="page-content" [dir]="languageService.direction()">
                <ng-content></ng-content>
            </div>
        </div>
    </div>
</div>

<adaa-float-action />

<adaa-spinner />
